import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  orderBy,
  query,
} from "firebase/firestore";
import { db } from "../../../db/firebase";

const ManageSubscriptions = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🔹 Fetch all subscribers
  const fetchSubscriptions = async () => {
    setLoading(true);
    try {
      const q = query(collection(db, "subscribers"), orderBy("subscribedAt", "desc"));
      const querySnapshot = await getDocs(q);
      const subsData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setSubscriptions(subsData);
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  // 🔹 Delete a subscriber
  const handleDelete = async (id, email) => {
    if (!window.confirm(`Remove subscriber: ${email}?`)) return;

    try {
      await deleteDoc(doc(db, "subscribers", id));
      alert(`Subscription deleted for ${email}`);
      setSubscriptions((prev) => prev.filter((sub) => sub.id !== id));
    } catch (error) {
      console.error("Error deleting subscription:", error);
      alert("Failed to delete subscription. Check console for details.");
    }
  };


  return (
    <div className="p-8 bg-offwhite min-h-screen">
      <h1 className="text-3xl font-bold text-primary mb-6">
        Newsletter Subscriptions
      </h1>

      {loading ? (
        <p>Loading subscribers...</p>
      ) : subscriptions.length === 0 ? (
        <p>No subscribers found.</p>
      ) : (
        <div className="overflow-x-auto bg-beige rounded-xl shadow-md">
          <table className="min-w-full border border-taupe rounded-xl">
            <thead>
              <tr className="bg-primary text-offwhite">
                <th className="p-3 text-left">Email</th>
                <th className="p-3 text-left">Subscribed At</th>
                <th className="p-3 text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {subscriptions.map((sub) => (
                <tr key={sub.id} className="border-t border-taupe">
                  <td className="p-3">{sub.email}</td>
                  <td className="p-3">
                    {sub.subscribedAt?.toDate
                      ? new Date(sub.subscribedAt.toDate()).toLocaleString()
                      : "—"}
                  </td>
                  <td className="p-3">
                    <button
                      onClick={() => handleDelete(sub.id, sub.email)}
                      className="bg-redburnt text-white px-3 py-1 rounded hover:bg-red-800"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ManageSubscriptions;
